import type { SVGProps } from 'react';

const SvgHelpTooltip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7"
    />
    <path
      fill="currentcolor"
      d="M12 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m2 2c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1v2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1v-2c.55 0 1-.45 1-1"
    />
  </svg>
);
export default SvgHelpTooltip;
